var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// #style-inject:#style-inject
function styleInject(css, { insertAt } = {}) {
  if (!css || typeof document === "undefined") return;
  const head = document.head || document.getElementsByTagName("head")[0];
  const style = document.createElement("style");
  style.type = "text/css";
  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

// src/style.css
styleInject("@keyframes fillout-embed-loading {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fillout-embed-popup-container {\n  padding: 40px 80px;\n}\n.fillout-embed-popup-iframe {\n  border-radius: 10px;\n  height: 100%;\n}\n.fillout-embed-popup-close {\n  position: absolute;\n  top: -15px;\n  right: -15px;\n  background: #171717;\n}\n.fillout-embed-popup-close:hover {\n  background: #272727;\n}\n.fillout-embed-slider-main {\n  position: relative;\n}\n.fillout-embed-slider-close {\n  padding: 20px 4px;\n}\n@media screen and (max-width: 480px) {\n  .fillout-embed-popup-container {\n    padding: 0;\n  }\n  .fillout-embed-popup-main {\n    display: flex;\n    flex-flow: column;\n    width: 100% !important;\n    height: 100% !important;\n  }\n  .fillout-embed-popup-iframe {\n    border-radius: 0;\n    height: unset;\n    flex-grow: 1;\n  }\n  .fillout-embed-popup-close {\n    position: unset;\n    top: 0;\n    right: 0;\n    margin: 4px 8px 4px auto;\n  }\n  .fillout-embed-slider-main {\n    flex-flow: column-reverse !important;\n    position: unset;\n    left: 0 !important;\n    right: 0 !important;\n  }\n  .fillout-embed-slider-iframe {\n    width: 100% !important;\n  }\n  .fillout-embed-slider-close {\n    padding: 6px;\n    border-radius: 50% !important;\n    margin: 4px 8px 4px auto;\n  }\n}\n");

// src/embeds/Standard.tsx
import React2, { useState as useState2 } from "react";

// src/embed.ts
import { useState, useEffect } from "react";
var FILLOUT_BASE_URL = "https://embed.fillout.com";
var generateEmbedId = () => {
  const min = 1e13;
  const max = 99999999999999;
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  return `${randomNumber}`;
};
var useFilloutEmbed = ({
  filloutId,
  domain,
  inheritParameters,
  parameters,
  dynamicResize
}) => {
  const [searchParams, setSearchParams] = useState();
  const [embedId, setEmbedId] = useState();
  useEffect(() => {
    setSearchParams(new URLSearchParams(window.location.search));
    setEmbedId(generateEmbedId());
  }, []);
  if (!searchParams || !embedId) return;
  const origin = domain ? `https://${domain}` : FILLOUT_BASE_URL;
  const iframeUrl = new URL(`${origin}/t/${encodeURIComponent(filloutId)}`);
  if (inheritParameters && searchParams) {
    for (const [key, value] of searchParams.entries()) {
      iframeUrl.searchParams.set(key, value);
    }
  }
  if (parameters) {
    for (const [key, value] of Object.entries(parameters)) {
      if (value) iframeUrl.searchParams.set(key, value);
    }
  }
  iframeUrl.searchParams.set("fillout-embed-id", embedId);
  if (dynamicResize) {
    iframeUrl.searchParams.set("fillout-embed-dynamic-resize", "true");
  }
  return {
    iframeUrl: iframeUrl.toString(),
    origin,
    embedId
  };
};

// src/components/Loading.tsx
import React from "react";
var Loading = () => /* @__PURE__ */ React.createElement(
  "div",
  {
    style: {
      border: "solid 2px #aaa",
      borderBottomColor: "white",
      borderRadius: "50%",
      width: 32,
      height: 32,
      animation: "fillout-embed-loading 1s infinite linear"
    }
  }
);

// src/messages.ts
import { useEffect as useEffect2 } from "react";
var useMessageListener = (embed, eventName, fn, options) => {
  const enabled = !(options == null ? void 0 : options.disabled);
  useEffect2(() => {
    if (embed && enabled) {
      const debug = location.href.includes("FILLOUT_EMBED_DEBUG");
      const listener = (event) => {
        try {
          if (event.origin === embed.origin && event.data.embedId === embed.embedId && event.data.type === eventName) {
            if (debug) {
              console.log(["fillout embed MESSAGE", eventName, event.data]);
            }
            fn(event.data);
          }
        } catch (err) {
        }
      };
      if (debug) console.log(["fillout embed MOUNT", eventName]);
      window.addEventListener("message", listener);
      return () => {
        if (debug) console.log(["fillout embed UNMOUNT", eventName]);
        window.removeEventListener("message", listener);
      };
    }
  }, [embed, eventName, fn, enabled]);
};

// src/events.ts
var useFilloutEvents = (embed, events) => {
  useMessageListener(
    embed,
    "form_init",
    (data) => {
      var _a;
      return (_a = events.onInit) == null ? void 0 : _a.call(events, data.submissionUuid);
    },
    { disabled: !events.onInit }
  );
  useMessageListener(
    embed,
    "page_change",
    (data) => {
      var _a;
      return (_a = events.onPageChange) == null ? void 0 : _a.call(events, data.submissionUuid, data.stepId);
    },
    { disabled: !events.onPageChange }
  );
  useMessageListener(
    embed,
    "form_submit",
    (data) => {
      var _a;
      return (_a = events.onSubmit) == null ? void 0 : _a.call(events, data.submissionUuid);
    },
    { disabled: !events.onSubmit }
  );
};

// src/embeds/Standard.tsx
var Standard = ({
  filloutId,
  domain,
  inheritParameters,
  parameters,
  dynamicResize,
  onInit,
  onPageChange,
  onSubmit
}) => {
  const [loading, setLoading] = useState2(true);
  const embed = useFilloutEmbed({
    filloutId,
    domain,
    inheritParameters,
    parameters,
    dynamicResize
  });
  useFilloutEvents(embed, { onInit, onPageChange, onSubmit });
  const [height, setHeight] = useState2();
  useMessageListener(
    embed,
    "form_resized",
    (data) => {
      const newHeight = data.size;
      if (typeof newHeight === "number") {
        setHeight(newHeight);
      }
    },
    { disabled: !dynamicResize }
  );
  return /* @__PURE__ */ React2.createElement(
    "div",
    {
      className: "fillout-standard-embed",
      style: {
        height: !dynamicResize ? "100%" : typeof height === "number" ? height : 256,
        transition: dynamicResize ? "height 150ms ease" : void 0
      }
    },
    loading && /* @__PURE__ */ React2.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          minHeight: 256
        }
      },
      /* @__PURE__ */ React2.createElement(Loading, null)
    ),
    embed && /* @__PURE__ */ React2.createElement(
      "iframe",
      {
        src: embed.iframeUrl,
        allow: "microphone; camera; geolocation",
        title: "Embedded Form",
        onLoad: () => setLoading(false),
        style: {
          width: !loading ? "100%" : 0,
          height: !loading ? "100%" : 0,
          opacity: !loading ? 1 : 0,
          borderRadius: 10,
          border: 0,
          minHeight: 256
        }
      }
    )
  );
};

// src/embeds/FullScreen.tsx
import React3, { useState as useState3 } from "react";
var FullScreen = ({
  filloutId,
  domain,
  inheritParameters,
  parameters,
  onInit,
  onPageChange,
  onSubmit
}) => {
  const [loading, setLoading] = useState3(true);
  const embed = useFilloutEmbed({
    filloutId,
    domain,
    inheritParameters,
    parameters
  });
  useFilloutEvents(embed, { onInit, onPageChange, onSubmit });
  return /* @__PURE__ */ React3.createElement(
    "div",
    {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%"
      }
    },
    loading && /* @__PURE__ */ React3.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%"
        }
      },
      /* @__PURE__ */ React3.createElement(Loading, null)
    ),
    embed && /* @__PURE__ */ React3.createElement(
      "iframe",
      {
        src: embed.iframeUrl,
        allow: "microphone; camera; geolocation",
        title: "Embedded Form",
        style: {
          border: 0,
          width: !loading ? "100%" : 0,
          height: !loading ? "100%" : 0,
          opacity: !loading ? 1 : 0
        },
        onLoad: () => setLoading(false)
      }
    )
  );
};

// src/embeds/Popup.tsx
import React5, { useEffect as useEffect4, useState as useState5 } from "react";

// src/components/Portal.tsx
import React4, { useEffect as useEffect3, useState as useState4 } from "react";
import { createPortal } from "react-dom";
var Portal = ({ children }) => {
  const [render, setRender] = useState4(false);
  useEffect3(() => {
    setRender(true);
  }, []);
  return render ? createPortal(children, document.body) : /* @__PURE__ */ React4.createElement(React4.Fragment, null);
};

// src/embeds/Popup.tsx
var Popup = (_a) => {
  var _b = _a, {
    isOpen: _isOpen,
    onClose: _onClose,
    width,
    height
  } = _b, props = __objRest(_b, [
    "isOpen",
    "onClose",
    "width",
    "height"
  ]);
  const [isOpen, setIsOpen] = useState5(false);
  useEffect4(() => {
    if (_isOpen) setTimeout(() => setIsOpen(true), 10);
    else setIsOpen(false);
  }, [_isOpen]);
  const onClose = () => {
    if (!isOpen) return;
    setIsOpen(false);
    setTimeout(_onClose, 250);
  };
  return /* @__PURE__ */ React5.createElement(Portal, null, /* @__PURE__ */ React5.createElement(
    PopupContainer,
    {
      isOpen: _isOpen,
      isOpenAnimate: isOpen,
      onClose,
      width,
      height
    },
    _isOpen && /* @__PURE__ */ React5.createElement(PopupContent, __spreadValues({ onClose }, props))
  ));
};
var PopupContent = ({
  filloutId,
  domain,
  inheritParameters,
  parameters,
  onClose,
  onInit,
  onPageChange,
  onSubmit
}) => {
  const [loading, setLoading] = useState5(true);
  const embed = useFilloutEmbed({
    filloutId,
    domain,
    inheritParameters,
    parameters
  });
  useFilloutEvents(embed, { onInit, onPageChange, onSubmit });
  return /* @__PURE__ */ React5.createElement(React5.Fragment, null, !loading && /* @__PURE__ */ React5.createElement(CloseButton, { onClick: onClose }), embed && /* @__PURE__ */ React5.createElement(
    "iframe",
    {
      src: embed.iframeUrl,
      allow: "microphone; camera; geolocation",
      title: "Embedded Form",
      className: "fillout-embed-popup-iframe",
      style: {
        border: 0,
        width: "100%",
        opacity: !loading ? 1 : 0
      },
      onLoad: () => setLoading(false)
    }
  ), loading && /* @__PURE__ */ React5.createElement(
    "div",
    {
      style: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }
    },
    /* @__PURE__ */ React5.createElement(Loading, null)
  ));
};
var PopupContainer = ({
  children,
  isOpen,
  isOpenAnimate,
  onClose,
  width,
  height
}) => /* @__PURE__ */ React5.createElement(
  "div",
  {
    onClick: onClose,
    className: "fillout-embed-popup-container",
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.65)",
      backdropFilter: "blur(4px)",
      transition: "opacity 0.25s ease-in-out",
      zIndex: 1e13,
      boxSizing: "border-box",
      opacity: isOpenAnimate ? 1 : 0,
      display: isOpen ? "flex" : "none",
      justifyContent: "center",
      alignItems: "center"
    }
  },
  /* @__PURE__ */ React5.createElement(
    "div",
    {
      className: "fillout-embed-popup-main",
      style: {
        position: "relative",
        width: width || "100%",
        height: height || "100%",
        maxWidth: "100%",
        maxHeight: "100%"
      }
    },
    children
  )
);
var CloseButton = ({ onClick }) => /* @__PURE__ */ React5.createElement(
  "button",
  {
    onClick: (e) => {
      e.stopPropagation();
      onClick();
    },
    className: "fillout-embed-popup-close",
    style: {
      width: 24,
      height: 24,
      textAlign: "center",
      cursor: "pointer",
      transition: "opacity 0.5s ease-in-out",
      textDecoration: "none",
      color: "white",
      borderRadius: "50%",
      padding: 6,
      boxSizing: "content-box",
      border: 0
    }
  },
  /* @__PURE__ */ React5.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor",
      strokeWidth: "2"
    },
    /* @__PURE__ */ React5.createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18L18 6M6 6l12 12"
      }
    )
  )
);

// src/embeds/PopupButton.tsx
import React7, { useState as useState6 } from "react";

// src/components/Button.tsx
import React6 from "react";
var buttonSizeStyles = {
  small: {
    padding: "8px 12px",
    fontSize: 16,
    borderRadius: 28
  },
  medium: {
    padding: "10px 14px",
    fontSize: 18,
    borderRadius: 32
  },
  large: {
    padding: "12px 14px",
    fontSize: 20,
    borderRadius: 32
  }
};
var buttonFloatStyles = {
  bottomRight: {
    position: "fixed",
    bottom: 32,
    right: 32,
    zIndex: 9999999
  },
  bottomLeft: {
    position: "fixed",
    bottom: 32,
    left: 32,
    zIndex: 9999999
  }
};
var hexToRgb = (hex) => {
  if (typeof hex !== "string" || !/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex)) {
    return [59, 130, 246];
  }
  let bigint = parseInt(hex.slice(1), 16);
  let r = bigint >> 16 & 255;
  let g = bigint >> 8 & 255;
  let b = bigint & 255;
  return [r, g, b];
};
var getLuminance = (hexColor) => {
  let [r, g, b] = hexToRgb(hexColor);
  const getComponent = (color) => {
    color /= 255;
    return color <= 0.03928 ? color / 12.92 : Math.pow((color + 0.055) / 1.055, 2.4);
  };
  r = getComponent(r);
  g = getComponent(g);
  b = getComponent(b);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};
var Button = ({
  onClick,
  text = "Open form",
  color = "#3b82f6",
  size = "medium",
  float
}) => {
  const textColor = getLuminance(color) > 0.5 ? "black" : "white";
  return /* @__PURE__ */ React6.createElement(
    "button",
    {
      onClick,
      style: __spreadValues(__spreadValues({
        cursor: "pointer",
        fontFamily: "Helvetica, Arial, sans-serif",
        display: "inline-block",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textDecoration: "none",
        fontWeight: "bold",
        textAlign: "center",
        margin: 0,
        border: "medium",
        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
        backgroundColor: color,
        color: textColor || "white"
      }, buttonSizeStyles[size]), float && buttonFloatStyles[float])
    },
    text
  );
};

// src/embeds/PopupButton.tsx
var PopupButton = ({
  filloutId,
  domain,
  inheritParameters,
  parameters,
  width,
  height,
  onInit,
  onPageChange,
  onSubmit,
  text,
  color,
  size,
  float
}) => {
  const [isOpen, setIsOpen] = useState6(false);
  return /* @__PURE__ */ React7.createElement(React7.Fragment, null, /* @__PURE__ */ React7.createElement(
    Button,
    {
      onClick: () => setIsOpen(true),
      text,
      color,
      size,
      float
    }
  ), /* @__PURE__ */ React7.createElement(
    Popup,
    {
      filloutId,
      domain,
      inheritParameters,
      parameters,
      isOpen,
      onClose: () => setIsOpen(false),
      onInit,
      onPageChange,
      onSubmit,
      width,
      height
    }
  ));
};

// src/embeds/Slider.tsx
import React8, { useEffect as useEffect5, useState as useState7 } from "react";
var Slider = (_a) => {
  var _b = _a, {
    isOpen: _isOpen,
    onClose: _onClose
  } = _b, props = __objRest(_b, [
    "isOpen",
    "onClose"
  ]);
  const [isOpen, setIsOpen] = useState7(false);
  useEffect5(() => {
    if (_isOpen) setTimeout(() => setIsOpen(true), 10);
    else setIsOpen(false);
  }, [_isOpen]);
  const onClose = () => {
    if (!isOpen) return;
    setIsOpen(false);
    setTimeout(_onClose, 250);
  };
  return /* @__PURE__ */ React8.createElement(Portal, null, /* @__PURE__ */ React8.createElement(
    SliderContainer,
    {
      isOpen: _isOpen,
      isOpenAnimate: isOpen,
      onClose
    },
    _isOpen && /* @__PURE__ */ React8.createElement(SliderContent, __spreadValues({ onClose }, props))
  ));
};
var SliderContent = ({
  filloutId,
  domain,
  inheritParameters,
  parameters,
  sliderDirection = "right",
  onClose,
  onInit,
  onPageChange,
  onSubmit
}) => {
  const [loading, setLoading] = useState7(true);
  const embed = useFilloutEmbed({
    filloutId,
    domain,
    inheritParameters,
    parameters
  });
  useFilloutEvents(embed, { onInit, onPageChange, onSubmit });
  const sliderLeft = sliderDirection === "left";
  const sliderOpen = !loading;
  return /* @__PURE__ */ React8.createElement(React8.Fragment, null, loading && /* @__PURE__ */ React8.createElement(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%"
      }
    },
    /* @__PURE__ */ React8.createElement(Loading, null)
  ), /* @__PURE__ */ React8.createElement(
    "div",
    {
      className: "fillout-embed-slider-main",
      style: __spreadValues({
        display: "flex",
        justifyContent: sliderLeft ? "start" : "end",
        flexDirection: sliderLeft ? "row" : "row-reverse",
        alignItems: "center",
        height: !loading ? "100%" : 0,
        transitionProperty: sliderLeft ? "left" : "right",
        transitionDuration: "0.25s",
        transitionTimingFunction: "ease-in-out"
      }, sliderLeft ? {
        left: sliderOpen ? 0 : "-80%"
      } : {
        right: sliderOpen ? 0 : "-80%"
      })
    },
    embed && /* @__PURE__ */ React8.createElement(
      "iframe",
      {
        src: embed.iframeUrl,
        allow: "microphone; camera; geolocation",
        title: "Embedded Form",
        className: "fillout-embed-slider-iframe",
        style: {
          border: 0,
          width: !loading ? "80%" : 0,
          height: !loading ? "100%" : 0,
          opacity: !loading ? 1 : 0
        },
        onLoad: () => setLoading(false)
      }
    ),
    !loading && /* @__PURE__ */ React8.createElement(CloseButton2, { onClick: onClose, sliderLeft })
  ));
};
var SliderContainer = ({
  children,
  isOpen,
  isOpenAnimate,
  onClose
}) => /* @__PURE__ */ React8.createElement(
  "div",
  {
    onClick: onClose,
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.65)",
      transition: "opacity 0.25s ease-in-out",
      zIndex: 1e13,
      opacity: isOpenAnimate ? 1 : 0,
      display: isOpen ? "block" : "none"
    }
  },
  children
);
var CloseButton2 = ({
  onClick,
  sliderLeft
}) => /* @__PURE__ */ React8.createElement(
  "button",
  {
    onClick: (e) => {
      e.stopPropagation();
      onClick();
    },
    className: "fillout-embed-slider-close",
    style: __spreadValues({
      border: 0,
      display: "flex",
      background: "#171717",
      color: "white",
      cursor: "pointer"
    }, sliderLeft ? {
      borderTopRightRadius: 15,
      borderBottomRightRadius: 15
    } : {
      borderTopLeftRadius: 15,
      borderBottomLeftRadius: 15
    })
  },
  /* @__PURE__ */ React8.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor",
      strokeWidth: "2",
      style: {
        width: 24,
        height: 24
      }
    },
    /* @__PURE__ */ React8.createElement(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M6 18L18 6M6 6l12 12"
      }
    )
  )
);

// src/embeds/SliderButton.tsx
import React9, { useState as useState8 } from "react";
var SliderButton = ({
  filloutId,
  domain,
  inheritParameters,
  parameters,
  sliderDirection,
  onInit,
  onPageChange,
  onSubmit,
  text,
  color,
  size,
  float
}) => {
  const [isOpen, setIsOpen] = useState8(false);
  return /* @__PURE__ */ React9.createElement(React9.Fragment, null, /* @__PURE__ */ React9.createElement(
    Button,
    {
      onClick: () => setIsOpen(true),
      text,
      color,
      size,
      float
    }
  ), /* @__PURE__ */ React9.createElement(
    Slider,
    {
      filloutId,
      domain,
      inheritParameters,
      parameters,
      sliderDirection,
      isOpen,
      onClose: () => setIsOpen(false),
      onInit,
      onPageChange,
      onSubmit
    }
  ));
};
export {
  FullScreen as FilloutFullScreenEmbed,
  Popup as FilloutPopupEmbed,
  PopupButton as FilloutPopupEmbedButton,
  Slider as FilloutSliderEmbed,
  SliderButton as FilloutSliderEmbedButton,
  Standard as FilloutStandardEmbed
};
